/* eslint-disable no-underscore-dangle */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */

import * as THREE from 'three'

import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass.js'
import { DEFAULT_THREE_NATIVE_LAYER } from 'Renderer/constants'

class CustomOutlinePass extends OutlinePass {

    constructor(resolution, scene, camera, selectedObjects, occlusionScene) {
        super(resolution, scene, camera, selectedObjects)
        this.occlusionScene = occlusionScene

        this.selectedEdgeColor = new THREE.Color(0.0, 1.0, 1.0)
        this.selectedEdgeStrength = 3.0

        this.sceneOriginalVisibility = new Map()
    }

    render( renderer, writeBuffer, readBuffer, deltaTime, maskActive ) {
        if (this.selectedObjects.length > 0) {
            // this.saveSceneVisibility()

            // Enable all camera layers as static stackables are on a different layer
            this.renderCamera.layers.enableAll()

            // eslint-disable-next-line no-underscore-dangle
            renderer.getClearColor(this._oldClearColor)
            this.oldClearAlpha = renderer.getClearAlpha()
            const oldAutoClear = renderer.autoClear

            renderer.autoClear = false

            if ( maskActive ) renderer.state.buffers.stencil.setTest( false )

            renderer.setClearColor( 0xffff00, 1 )

            // Make selected objects invisible
            this.changeVisibilityOfSelectedObjects( false )

            renderer.setRenderTarget( this.renderTargetDepthBuffer )
            renderer.clear()

            if (this.occlusionScene) {
                this.occlusionScene.traverse((object) => {
                    if (object.isMesh && object.depthPackMaterial) {
                        object.originalMaterial = object.material
                        object.material = object.depthPackMaterial
                    }
                })
                renderer.render(this.occlusionScene, this.renderCamera)
                this.occlusionScene.traverse((object) => {
                    if (object.isMesh && object.depthPackMaterial && object.originalMaterial) {
                        object.material = object.originalMaterial
                        delete(object.originalMaterial)
                    }
                })
            }

            const currentBackground = this.renderScene.background
            this.renderScene.background = null

            // 1. Draw Non Selected objects in the depth buffer
            this.renderScene.overrideMaterial = this.depthMaterial
            renderer.render( this.renderScene, this.renderCamera )


            // Make selected objects visible
            this.changeVisibilityOfSelectedObjects( true )
            // eslint-disable-next-line no-underscore-dangle
            this._visibilityCache.clear()

            // Update Texture Matrix for Depth compare
            this.updateTextureMatrix()

            // Make non selected objects invisible, and draw only the selected objects, by comparing the depth buffer of non selected objects
            this.changeVisibilityOfNonSelectedObjects( false )
            this.renderScene.overrideMaterial = null

//            this.renderScene.overrideMaterial = this.prepareMaskMaterial
            this.prepareMaskMaterial.uniforms.cameraNearFar.value.set( this.renderCamera.near, this.renderCamera.far )
            this.prepareMaskMaterial.uniforms.depthTexture.value = this.renderTargetDepthBuffer.texture
            this.prepareMaskMaterial.uniforms.textureMatrix.value = this.textureMatrix
            this.setupObjectMaskPass()

            renderer.setRenderTarget( this.renderTargetMaskBuffer )
            renderer.clear()
            renderer.render( this.renderScene, this.renderCamera )
//            this.renderScene.overrideMaterial = null

            this.clearObjectMaskPass()
            this.changeVisibilityOfNonSelectedObjects( true )
            // eslint-disable-next-line no-underscore-dangle
            this._visibilityCache.clear()

            this.renderScene.background = currentBackground

            // 2. Downsample to Half resolution
            this.fsQuad.material = this.materialCopy
            this.copyUniforms.tDiffuse.value = this.renderTargetMaskBuffer.texture
            renderer.setRenderTarget( this.renderTargetMaskDownSampleBuffer )
            renderer.clear()
            this.fsQuad.render( renderer )

            this.tempPulseColor1.copy( this.visibleEdgeColor )
            this.tempPulseColor2.copy( this.hiddenEdgeColor )

            if ( this.pulsePeriod > 0 ) {

                const scalar = ( 1 + 0.25 ) / 2 + Math.cos( performance.now() * 0.01 / this.pulsePeriod ) * ( 1.0 - 0.25 ) / 2
                this.tempPulseColor1.multiplyScalar( scalar )
                this.tempPulseColor2.multiplyScalar( scalar )

            }

            // 3. Apply Edge Detection Pass
            this.fsQuad.material = this.edgeDetectionMaterial
            this.edgeDetectionMaterial.uniforms.maskTexture.value = this.renderTargetMaskDownSampleBuffer.texture
            this.edgeDetectionMaterial.uniforms.texSize.value.set( this.renderTargetMaskDownSampleBuffer.width, this.renderTargetMaskDownSampleBuffer.height )
            this.edgeDetectionMaterial.uniforms.visibleEdgeColor.value = this.tempPulseColor1
            this.edgeDetectionMaterial.uniforms.hiddenEdgeColor.value = this.tempPulseColor2
            this.edgeDetectionMaterial.uniforms.selectedEdgeColor.value = this.selectedEdgeColor
            renderer.setRenderTarget( this.renderTargetEdgeBuffer1 )
            renderer.clear()
            this.fsQuad.render( renderer )

            // 4. Apply Blur on Half res
            this.fsQuad.material = this.separableBlurMaterial1
            this.separableBlurMaterial1.uniforms.colorTexture.value = this.renderTargetEdgeBuffer1.texture
            this.separableBlurMaterial1.uniforms.direction.value = OutlinePass.BlurDirectionX
            this.separableBlurMaterial1.uniforms.kernelRadius.value = this.edgeThickness
            renderer.setRenderTarget( this.renderTargetBlurBuffer1 )
            renderer.clear()
            this.fsQuad.render( renderer )
            this.separableBlurMaterial1.uniforms.colorTexture.value = this.renderTargetBlurBuffer1.texture
            this.separableBlurMaterial1.uniforms.direction.value = OutlinePass.BlurDirectionY
            renderer.setRenderTarget( this.renderTargetEdgeBuffer1 )
            renderer.clear()
            this.fsQuad.render( renderer )

            // Apply Blur on quarter res
            this.fsQuad.material = this.separableBlurMaterial2
            this.separableBlurMaterial2.uniforms.colorTexture.value = this.renderTargetEdgeBuffer1.texture
            this.separableBlurMaterial2.uniforms.direction.value = OutlinePass.BlurDirectionX
            renderer.setRenderTarget( this.renderTargetBlurBuffer2 )
            renderer.clear()
            this.fsQuad.render( renderer )
            this.separableBlurMaterial2.uniforms.colorTexture.value = this.renderTargetBlurBuffer2.texture
            this.separableBlurMaterial2.uniforms.direction.value = OutlinePass.BlurDirectionY
            renderer.setRenderTarget( this.renderTargetEdgeBuffer2 )
            renderer.clear()
            this.fsQuad.render( renderer )

            // Blend it additively over the input texture
            this.fsQuad.material = this.overlayMaterial
            this.overlayMaterial.uniforms.maskTexture.value = this.renderTargetMaskBuffer.texture
            this.overlayMaterial.uniforms.edgeTexture1.value = this.renderTargetEdgeBuffer1.texture
            this.overlayMaterial.uniforms.edgeTexture2.value = this.renderTargetEdgeBuffer2.texture
            this.overlayMaterial.uniforms.patternTexture.value = this.patternTexture
            this.overlayMaterial.uniforms.edgeStrength.value = this.edgeStrength
            this.overlayMaterial.uniforms.selectedEdgeStrength.value = this.selectedEdgeStrength
            this.overlayMaterial.uniforms.edgeGlow.value = this.edgeGlow
            this.overlayMaterial.uniforms.usePatternTexture.value = this.usePatternTexture

            if ( maskActive ) renderer.state.buffers.stencil.setTest( true )

            renderer.setRenderTarget( readBuffer )
            this.fsQuad.render( renderer )

            // eslint-disable-next-line no-underscore-dangle
            renderer.setClearColor( this._oldClearColor, this.oldClearAlpha )
            renderer.autoClear = oldAutoClear

            // Restore default camera state 
            this.renderCamera.layers.set(DEFAULT_THREE_NATIVE_LAYER)
            
            // this.restoreSceneVisibility()
        }

        if ( this.renderToScreen ) {
            this.fsQuad.material = this.materialCopy
            this.copyUniforms.tDiffuse.value = readBuffer.texture
            renderer.setRenderTarget( null )
            this.fsQuad.render( renderer )
        }
    }

    getPrepareMaskMaterial() {

        return new THREE.ShaderMaterial( {

            uniforms: {
                'depthTexture': { value: null },
                'cameraNearFar': { value: new THREE.Vector2( 0.5, 0.5 ) },
                'textureMatrix': { value: null },
                'selected': { value: 0 }
            },

            vertexShader:
                `#include <morphtarget_pars_vertex>
                #include <skinning_pars_vertex>

                varying vec4 projTexCoord;
                varying vec4 vPosition;
                uniform mat4 textureMatrix;

                void main() {

                    #include <skinbase_vertex>
                    #include <begin_vertex>
                    #include <morphtarget_vertex>
                    #include <skinning_vertex>
                    #include <project_vertex>

                    vPosition = mvPosition;
                    vec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );
                    projTexCoord = textureMatrix * worldPosition;

                }`,

            fragmentShader:
                `#include <packing>
                varying vec4 vPosition;
                varying vec4 projTexCoord;
                uniform sampler2D depthTexture;
                uniform vec2 cameraNearFar;
                uniform int selected;

                void main() {
                    float depth = unpackRGBAToDepth(texture2DProj( depthTexture, projTexCoord ));
                    float viewZ = - DEPTH_TO_VIEW_Z( depth, cameraNearFar.x, cameraNearFar.y );
                    float depthTest = (-vPosition.z > viewZ) ? 1.0 : 0.0;
                    float selectedFlag = selected > 0 ? 1.0 : 0.0;
                    gl_FragColor = vec4(0.0, depthTest, selectedFlag, 1.0);
                }`

        } )

    }

    getEdgeDetectionMaterial() {

        return new THREE.ShaderMaterial( {

            uniforms: {
                'maskTexture': { value: null },
                'texSize': { value: new THREE.Vector2( 0.5, 0.5 ) },
                'visibleEdgeColor': { value: new THREE.Vector3( 1.0, 1.0, 1.0 ) },
                'hiddenEdgeColor': { value: new THREE.Vector3( 1.0, 1.0, 1.0 ) },
                'selectedEdgeColor': { value: new THREE.Vector3( 1.0, 1.0, 1.0 ) },
            },

            vertexShader:
                `varying vec2 vUv;

                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
                }`,

            fragmentShader:
                `varying vec2 vUv;

                uniform sampler2D maskTexture;
                uniform vec2 texSize;
                uniform vec3 visibleEdgeColor;
                uniform vec3 hiddenEdgeColor;
                uniform vec3 selectedEdgeColor;

                void main() {
                    vec2 invSize = 1.0 / texSize;
                    vec4 uvOffset = vec4(1.0, 0.0, 0.0, 1.0) * vec4(invSize, invSize);
                    vec4 c1 = texture2D( maskTexture, vUv + uvOffset.xy);
                    vec4 c2 = texture2D( maskTexture, vUv - uvOffset.xy);
                    vec4 c3 = texture2D( maskTexture, vUv + uvOffset.yw);
                    vec4 c4 = texture2D( maskTexture, vUv - uvOffset.yw);

                    vec3 diff1 = (c1.rgb - c2.rgb)*0.5;
                    vec3 diff2 = (c3.rgb - c4.rgb)*0.5;
                    float d = length(vec2(diff1.r, diff2.r));

//                    bool anyOne = any(bvec4(c1.r > 0.0, c2.r > 0.0, c3.r > 0.0, c4.r > 0.0));
                    bool notAll = !all(bvec4(c1.r > 0.0, c2.r > 0.0, c3.r > 0.0, c4.r > 0.0));
//                    float d = anyOne && notAll ? 1.0 : 0.0;

                    bool anySelected = any(bvec4(c1.b > 0.0, c2.b > 0.0, c3.b > 0.0, c4.b > 0.0));
                    float s = anySelected && notAll ? 1.0 : 0.0;

                    float a1 = min(c1.g, c2.g);
                    float a2 = min(c3.g, c4.g);
                    float visibilityFactor = min(a1, a2);

                    vec3 visibleColor = s > 0.5 ? selectedEdgeColor : visibleEdgeColor;
                    vec3 edgeColor = 1.0 - visibilityFactor > 0.001 ? visibleColor : hiddenEdgeColor;

                    gl_FragColor = vec4(edgeColor, 1.0) * vec4(d);
                }`
        } )
    }

    getOverlayMaterial() {

        return new THREE.ShaderMaterial( {

            uniforms: {
                'maskTexture': { value: null },
                'edgeTexture1': { value: null },
                'edgeTexture2': { value: null },
                'patternTexture': { value: null },
                'edgeStrength': { value: 1.0 },
                'selectedEdgeStrength': { value: 1.0 },
                'edgeGlow': { value: 1.0 },
                'usePatternTexture': { value: 0.0 }
            },

            vertexShader:
                `varying vec2 vUv;

                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
                }`,

            fragmentShader:
                `varying vec2 vUv;

                uniform sampler2D maskTexture;
                uniform sampler2D edgeTexture1;
                uniform sampler2D edgeTexture2;
                uniform sampler2D patternTexture;
                uniform float edgeStrength;
                uniform float selectedEdgeStrength;
                uniform float edgeGlow;
                uniform bool usePatternTexture;

                void main() {
                    vec4 edgeValue1 = texture2D(edgeTexture1, vUv);
                    vec4 edgeValue2 = texture2D(edgeTexture2, vUv);
                    vec4 maskColor = texture2D(maskTexture, vUv);
                    vec4 patternColor = texture2D(patternTexture, 6.0 * vUv);
                    float visibilityFactor = 1.0 - maskColor.g > 0.0 ? 1.0 : 0.5;
                    vec4 edgeValue = edgeValue1 + edgeValue2 * edgeGlow;
                    float selectedFlag = maskColor.b;
                    selectedFlag = 0.0;
                    float strength = selectedFlag > 0.5 ? selectedEdgeStrength : edgeStrength;
                    vec4 finalColor = strength * maskColor.r * edgeValue;
                    if(usePatternTexture)
                        finalColor += + visibilityFactor * (1.0 - maskColor.r) * (1.0 - patternColor.r);
                    gl_FragColor = finalColor;
                }`,
            blending: THREE.NormalBlending,
            depthTest: false,
            depthWrite: false,
            transparent: true
        } )

    }

    setupObjectMaskPass() {
        for (let i = 0; i < this.selectedObjects.length; i += 1) {
            const selectedObject = this.selectedObjects[i]
            if (selectedObject) {
                const isSelected = selectedObject.isSelected
                selectedObject.traverse((object) => {
                    if (object.material && !object.originalMaterial) {
                        object.originalMaterial = object.material
                        object.material = this.prepareMaskMaterial.clone()
                        object.material.uniforms.selected.value = isSelected ? 1 : 0
                        // threejs clones the texture, we need to reuse the existing one
                        object.material.uniforms.depthTexture.value = this.prepareMaskMaterial.uniforms.depthTexture.value
                    }
                })
            }
        }
    }

    clearObjectMaskPass() {
        for (let i = 0; i < this.selectedObjects.length; i += 1) {
            const selectedObject = this.selectedObjects[i]
            if (selectedObject) {
                selectedObject.traverse((object) => {
                    if (object.originalMaterial) {
                        object.material = object.originalMaterial
                        delete(object.originalMaterial)
                    }
                })
            }
        }
    }

    changeVisibilityOfSelectedObjects(bVisible) {
        const cache = this._visibilityCache

        for (let i = 0; i < this.selectedObjects.length; i += 1) {
            const selectedObject = this.selectedObjects[i]
            if (selectedObject) {
                selectedObject.traverse((object) => {
                    if (!object.isMesh) {
                        return
                    }
                    if (!bVisible) {
                        if (!cache.has(object)) {
                            cache.set(object, object.visible)
                        }
                        object.visible = bVisible
                    } else {
                        object.visible = cache.get(object)
                    }
                })
            }
        }
    }

    changeVisibilityOfNonSelectedObjects( bVisible ) {
        const cache = this._visibilityCache
        const selectedMeshes = []

        for (let i = 0; i < this.selectedObjects.length; i += 1) {
            const selectedObject = this.selectedObjects[i]
            if (selectedObject) {
                selectedObject.traverse((object) => {
                    if (object.isMesh && !selectedMeshes.includes(object)) {
                        selectedMeshes.push(object)
                    }
                })
            }
        }

        this.renderScene.traverse((object) => {
            if (object.isMesh || object.isSprite) {
                // only meshes and sprites are supported by OutlinePass
                if (!selectedMeshes.includes(object)) {
                    if (!bVisible) {
                        if (!cache.has(object)) {
                            cache.set(object, object.visible)
                        }
                        object.visible = bVisible
                    } else if (cache.has(object)) {
                        object.visible = cache.get(object)
                    }
                }
            } else if (object.isPoints || object.isLine) {
                // the visibilty of points and lines is always set to false in order to
                // not affect the outline computation
                if (bVisible) {
                    object.visible = cache.get(object) // restore
                } else {
                    cache.set(object, object.visible)
                    object.visible = bVisible
                }
            }
        })
    }

    saveSceneVisibility() {
        this.sceneOriginalVisibility.clear()
        this.renderScene.traverse((object) => {
            if (!object.isMesh) {
                return
            }
            this.sceneOriginalVisibility.set(object, object.visible)
        })
    }

    restoreSceneVisibility() {
        this.renderScene.traverse((object) => {
            if (!object.isMesh) {
                return
            }
            if (this.sceneOriginalVisibility.has(object)) {
                const prevVisible = this.sceneOriginalVisibility.get(object)
                if (prevVisible !== object.visible) {
                    object.visible = prevVisible
                }
            }
        })
    }
}

export default CustomOutlinePass

/* eslint-enable no-param-reassign */
/* eslint-enable class-methods-use-this */
/* eslint-enable no-underscore-dangle */
